/**
 * Non-WebGL / reduced-motion / GPU-failure fallback. Must visually rhyme
 * with the WebGL scene (same cosmic dark + amber/fire/gold palette) using
 * only CSS — no canvas, no JS animation loop. This directly replaces the current
 * live site's `.hero-bg-orb` blurred-div approach (see index.html), so it
 * also doubles as a faithful "what the real site already does" baseline.
 * Decorative only — aria-hidden, never carries content.
 */
export function WebglFallback() {
  return (
    <div aria-hidden="true" className="absolute inset-0 overflow-hidden">
      <div
        className="absolute -top-32 left-1/4 h-[420px] w-[420px] rounded-full opacity-60"
        style={{
          background:
            'radial-gradient(circle, #ff7a45 0%, #ff7a45 15%, rgba(255,122,69,0.4) 40%, transparent 70%)',
        }}
      />
      <div
        className="absolute top-1/3 -right-24 h-[380px] w-[380px] rounded-full opacity-50"
        style={{
          background:
            'radial-gradient(circle, #ffb95f 0%, #ffb95f 15%, rgba(255,185,95,0.35) 40%, transparent 70%)',
        }}
      />
      <div
        className="absolute bottom-0 left-1/3 h-[340px] w-[340px] rounded-full opacity-40"
        style={{
          background:
            'radial-gradient(circle, #e0983a 0%, #e0983a 15%, rgba(224,152,58,0.3) 40%, transparent 70%)',
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />
    </div>
  )
}